import { render, staticRenderFns } from "./SaveTemplates.vue?vue&type=template&id=783170b3&scoped=true&"
import script from "./SaveTemplates.vue?vue&type=script&lang=js&"
export * from "./SaveTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783170b3",
  null
  
)

export default component.exports